import type { AiChatPrompt, AiChatPromptSetId } from './aiChatPromptTypes';
import { aiChatPromptSets } from './promptSets';

export const getAiChatPromptSet = (promptSetId: AiChatPromptSetId): AiChatPrompt[] => {
  return aiChatPromptSets[promptSetId];
};

export const getRandomAiChatPrompts = (promptSetId: AiChatPromptSetId, count: number = 4): AiChatPrompt[] => {
  const prompts = getAiChatPromptSet(promptSetId);
  const shuffled = [...prompts].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, Math.min(count, prompts.length));
};
